<form *ngIf="fields" [ngClass]="{'invalid-submit': invalidSubmit}" [formGroup]="addEditFormDetails" (ngSubmit)="saveOrUpdate()" RestrictFocus >

  <div class="ui-grid ui-grid-responsive ui-fluid">

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4">
        <label [ngClass]="{'required': !fields.code.nullable}">{{ fields.code.keyName }}</label>
      </div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="code" pInputText [maxlength]="fields.code.width"/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditFormDetails" [validation]="fields.code"></app-validation-msg>
      </div>
    </div>

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4">
        <label [ngClass]="{'required': !fields.name.nullable}">{{ fields.name.keyName }}</label>
      </div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="name" pInputText [maxlength]="fields.name.width"/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditFormDetails" [validation]="fields.name"></app-validation-msg>
      </div>
    </div>

  </div>

  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0;">
      <button class="k-generic-btn" type="submit" pButton icon="fa fa-check"
              label="{{editingElement.id ? ('common.edit' | translate) :  ('common.add' | translate) }}"></button>
    </div>
  </p-footer>

</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-group/store-group-list/store-group-list-form.component.html